import {EmailClientType} from '../../../enums/email-client-type';
import moment, {Moment} from "moment";

export class EmailClientReq {
    id!: number;
    email!: string;
    description!: string;
    host!: string;
    username!: string;
    password!: string;
    port!: number;
    useSsl!: boolean;
    clientType!: EmailClientType
    connectionOk!: boolean;
    connectionError!: string;
    testMailReceiver!: string;

    private _lastUsed?: any;
    get lastUsed(): any {
        return this._lastUsed;
    }

    set lastUsed(value: any) {
        this._lastUsed = value != undefined ? moment(value) : undefined;
    }

    static FromRes(data: EmailClientRes): EmailClientReq {
        let item = new EmailClientReq();
        item.id = data.id;
        item.email = data.email;
        item.description = data.description;
        item.host = data.host;
        item.username = data.username;
        item.password = data.password;
        item.port = data.port;
        item.useSsl = data.useSsl;
        item.clientType = data.clientType;
        item.testMailReceiver = data.testMailReceiver;
        item.lastUsed = new Date(data.lastUsed);
        return item;
    }
}

export class EmailClientConnectionRes {
    message!: string;
    connectionOk!: boolean
}

export class EmailClientRes {
    id!: number;
    email!: string;
    description!: string;
    host!: string;
    username!: string;
    password!: string;
    port!: number;
    useSsl!: boolean;
    clientType!: EmailClientType
    connectionOk!: boolean;
    connectionError!: string;
    testMailReceiver!: string;

    private _lastUsed: any;
    get lastUsed(): any {
        return this._lastUsed;
    }

    set lastUsed(value: any) {
        this._lastUsed = moment(value);
    }
}